// Zuivere selectorfuncties rond het canvas-board -- geen React, geen DOM.
// Structurele (niet nominale) typen hier bewust, i.p.v. de echte CanvasFrame/
// CanvasPathStep uit ../types: dit houdt de module puur en onafhankelijk
// testbaar (net als cameraMath.ts), en de echte types passen er toch in
// omdat ze dezelfde velden bevatten.
import { rotatedBoundingBox, type Box } from './cameraMath';

export interface FrameLike {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation?: number;
}

export interface PathStepLike {
  type: 'overview' | 'focus';
  target_id?: string | null;
}

// Geen overzicht van het HELE bord, maar de begrenzing van alle frames plus
// een marge -- anders staat het overzicht vol lege ruimte omdat het bord
// zelf groter is dan de inhoud (zelfde reden als het prototype's overviewBox()).
export function overviewBox(frames: FrameLike[], margin = 260): Box {
  if (frames.length === 0) return { x: 0, y: 0, width: margin * 2, height: margin * 2 };
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  frames.forEach((frame) => {
    minX = Math.min(minX, frame.x);
    minY = Math.min(minY, frame.y);
    maxX = Math.max(maxX, frame.x + frame.width);
    maxY = Math.max(maxY, frame.y + frame.height);
  });
  return { x: minX - margin, y: minY - margin, width: maxX - minX + margin * 2, height: maxY - minY + margin * 2 };
}

export function boxForFrame(frame: FrameLike): Box {
  const box: Box = { x: frame.x, y: frame.y, width: frame.width, height: frame.height };
  return frame.rotation ? rotatedBoundingBox(box, frame.rotation) : box;
}

export interface ResolvedCurrentItem {
  isOverview: boolean;
  targetId: string | null;
}

// Spiegelt backend/sprekers/service.py::_resolve_current_item bewust 1:1
// (zelfde soort bewuste duplicatie als types.ts t.o.v. schemas.py) -- alleen
// gebruikt als fallback voor de allereerste render vóór het eerste
// SSE-event binnenkomt.
export function resolveIsOverviewAndTarget(
  path: PathStepLike[], pathIndex: number, manualOverview: boolean,
): ResolvedCurrentItem {
  if (path.length === 0) return { isOverview: true, targetId: null };
  const index = Math.max(0, Math.min(path.length - 1, pathIndex));
  const step = path[index];
  const isOverview = manualOverview || step.type === 'overview';
  const targetId = step.type === 'focus' ? step.target_id ?? null : null;
  return { isOverview, targetId };
}
